'use client'
import { Users, Handshake, GraduationCap } from "lucide-react";

const stats = [
    {
        icon: Users,
        value: "6,00,000+",
        label: "Candidates Trained & Certified",
    },
    {
        icon: Handshake,
        value: "650+",
        label: "Industry & Skilling Partners",
    },
    {
        icon: GraduationCap,
        value: "400+",
        label: "Skill Academies & Pradhan Mantri Kaushal Kendras",
    },
];

export default function StatsCards() {
    return (
        <section className="w-full bg-white pt-10 md:px-12">
            <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)]">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5">
                    {stats.map(({ icon: Icon, value, label }) => (
                        <div key={label}
                            className="flex items-center gap-4 rounded-md border border-gray-100 bg-blue-50 p-5"
                        >
                            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#0475B3]">
                                <Icon className="h-6 w-6 text-white" strokeWidth={1.75} />
                            </span>
                            <div>
                                <p className="text-2xl font-bold text-black">{value}</p>
                                <p className="mt-0.5 text-sm text-gray-600">{label}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}